import React from 'react';
import {
  Edit,
  SimpleForm,
  TextInput,
  NumberInput,
  ReferenceArrayInput,
  SelectArrayInput,
  DateInput,
} from 'react-admin';
import { required } from '../../lib/validation';

const PromoEdit = props => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput source="code" validate={required()} />
      <NumberInput source="amount" validate={required()} />
      <DateInput label="Start at" source="start_at" validate={required()} />
      <DateInput label="End at" source="end_at" validate={required()} />
      <ReferenceArrayInput label="Plans" source="plan_ids" reference="plans" validate={required()}>
        <SelectArrayInput optionText="name" />
      </ReferenceArrayInput>
    </SimpleForm>
  </Edit>
);

export default PromoEdit;



// WEBPACK FOOTER //
// ./src/resources/promos/PromoEdit.jsx